var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import styled from "styled-components";
import { Money } from "@upserve/financials";
import { Maybe } from "true-myth";
import useViewportDimensions from "helpers/hooks/useViewportDimensions";
import CreditCardForm from "components/credit_card/credit_card_form";
import Icon from "components/icon";
import { RequestStatus } from "types/requests";
import { StyledErrorHeader, StyledErrorText, } from "components/mobile_pay/views/error_page";
import Header from "components/digital_gift_cards/header";
import { StyledDGCPurchasePage } from "components/digital_gift_cards/purchase_page";
import { StyledDefaultGiftCardWrapper, StyledDGCMainContent, StyledGiftCardOutline, } from "components/digital_gift_cards/main_content";
import Footer from "components/digital_gift_cards/footer";
import OrderForm from "components/digital_gift_cards/order_form";
import { StyledWrapper } from "components/digital_gift_cards/error_page";
import { calculateLeftMargin } from "helpers/digital_gift_cards";
var DefaultGiftCard = require("images/default-gift-card.png");
var StyledFormWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 424px;\n  padding: 0 32px;\n\n  .upserve-dgc-terms {\n    display: none;\n  }\n\n  @media (max-width: 1024px) {\n    width: auto;\n  }\n"], ["\n  width: 424px;\n  padding: 0 32px;\n\n  .upserve-dgc-terms {\n    display: none;\n  }\n\n  @media (max-width: 1024px) {\n    width: auto;\n  }\n"])));
var DEFAULT_SETTINGS_VALUES = {
    storePrettyUrl: "preview-preview",
    ugMerchantKey: "preview",
    digitalGiftCardEnabled: true,
    name: "Preview Restaurant",
    street1: "123 Main Street",
    street2: "",
    city: "City",
    state: "RI",
    zip: "11111",
    phone: Maybe.of("555-555-5555"),
    minValue: Money(1),
    maxValue: Money(999),
    website: Maybe.of("https://upserve.com"),
    additionalDetails: Maybe.of(""),
};
export default function Preview(_a) {
    var logoUrl = _a.logoUrl, bannerUrl = _a.bannerUrl;
    var w = useViewportDimensions().w;
    var previewSettings = __assign(__assign({}, DEFAULT_SETTINGS_VALUES), { logoUrl: logoUrl,
        bannerUrl: bannerUrl });
    var giftCardImage = logoUrl.match({
        Just: function (url) { return (React.createElement(StyledGiftCardOutline, null,
            React.createElement("img", { src: url, alt: "gift card" }))); },
        Nothing: function () { return (React.createElement(StyledDefaultGiftCardWrapper, null,
            React.createElement("img", { src: DefaultGiftCard, alt: "gift card" }))); },
    });
    if (logoUrl.isNothing() && bannerUrl.isNothing()) {
        return (React.createElement(StyledWrapper, null,
            React.createElement(Icon, { type: "receipt-ghost" }),
            React.createElement(StyledErrorHeader, null, "Sorry!"),
            React.createElement(StyledErrorText, null, "Error loading your page preview.")));
    }
    return (React.createElement(StyledDGCPurchasePage, null,
        React.createElement(Header, { settings: previewSettings, leftMargin: calculateLeftMargin(w) }),
        React.createElement(StyledDGCMainContent, { leftMargin: calculateLeftMargin(w) },
            React.createElement(StyledFormWrapper, null,
                React.createElement(OrderForm, { settings: previewSettings, setFormValid: function () { }, setFormValues: function () { } }),
                React.createElement(CreditCardForm, { merchantInfo: {
                        ugMerchantKey: previewSettings.ugMerchantKey,
                        prettyUrl: previewSettings.storePrettyUrl,
                    }, paymentInfo: { balanceDue: Money(500) }, afterProcessedPaymentRequest: { type: RequestStatus.NOT_STARTED }, creditCardRequestStatus: RequestStatus.NOT_STARTED, submitCreditCardPayment: function () { }, setCreditCardRequestStatus: function () { }, externalSubmitDisabled: true }),
                React.createElement("h2", null, "This page is for preview only.")),
            giftCardImage),
        React.createElement(Footer, null)));
}
var templateObject_1;
